"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var image_1 = __importDefault(require("next/image"));
var link_1 = __importDefault(require("next/link"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var TARGET_PROVIDER_KEYS = new Set([
    '1x2gaming',
    'gameart',
    'habanero',
    'playngo',
    'penguinking',
    'slotmill',
    'spearheadstudios',
    'spinomenal',
]);
var PROVIDER_FILE_BY_KEY = {
    '1x2gaming': "/img/providers/1x2-GAMING.svg",
    gameart: '/img/providers/gameart.svg',
    habanero: '/img/providers/habanero.svg',
    playngo: "/img/providers/PLAY'N'GO.svg",
    // No dedicated local file in repo yet, keep default.
    penguinking: '/img/providers/default.svg',
    slotmill: '/img/providers/slotmill.svg',
    spearheadstudios: '/img/providers/Spearhead-Studios.svg',
    spinomenal: '/img/providers/spinomenal.svg',
};
var normalizeProviderKey = function (value) {
    return (value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
};
var Provider = function (_a) {
    var title = _a.title, slug = _a.slug;
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var config = (0, swr_hooks_1.useConfig)();
    var providerKey = normalizeProviderKey(title) || normalizeProviderKey(slug);
    var isTargetProvider = TARGET_PROVIDER_KEYS.has(providerKey);
    var mappedSrc = PROVIDER_FILE_BY_KEY[providerKey];
    var slugSrc = "/img/providers/".concat(slug, ".svg");
    var srcCandidates = [mappedSrc, slugSrc, '/img/providers/default.svg'].filter(function (src, index, all) { return Boolean(src) && all.indexOf(src) === index; });
    var _b = (0, react_1.useState)(0), srcIndex = _b[0], setSrcIndex = _b[1];
    (0, react_1.useEffect)(function () {
        setSrcIndex(0);
    }, [slug, title]);
    return (react_1.default.createElement(link_1.default, { href: generateUrlWithLang("/providers/".concat(slug.toLowerCase())), className: styles_module_scss_1.default.link },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.provider },
            react_1.default.createElement(image_1.default, { width: 80, height: 80, unoptimized: isTargetProvider, loading: "lazy", className: "swiper-lazy", src: srcCandidates[srcIndex], onError: function () {
                    setSrcIndex(function (current) { return Math.min(current + 1, srcCandidates.length - 1); });
                }, alt: title }),
            (config === null || config === void 0 ? void 0 : config.showProviderNameInProvidersHomePage) ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.providerTitle }, title)) : null)));
};
exports.default = Provider;
